<!-- 套餐信息 -->
<template>
  <div class="personal-package">
    <div class="personal-package-item">
      <div>
        <h1>套餐信息</h1>
        <div class="personal-package-con">
          <div class="dis-24">
            <div class="personal-package-list">
              <span>套餐类型</span>
              <span>{{packageInfo.detail.name}}</span>
            </div>
          </div>
          <div class="dis-24">
            <div class="personal-package-list">
              <span>辅导申请方向数量</span>
              <span>{{packageInfo.applyDirection}}</span>
            </div>
            <div class="personal-package-list">
              <span>辅导项目数量</span>
              <span>{{packageInfo.programCount}}</span>
            </div>
            <div class="personal-package-list">
              <span>SM修改轮次</span>
              <span>{{packageInfo.essaySMRound}}</span>
            </div>
            <div class="personal-package-list">
              <span>EM修改轮次</span>
              <span>{{packageInfo.essayEMRound}}</span>
            </div>
          </div>
          <div class="dis-24">
            <div class="personal-package-list">
              <span>CV修改数量</span>
              <span>{{packageInfo.cvCount}}</span>
            </div>
            <div class="personal-package-list">
              <span>CV修改轮次</span>
              <span>{{packageInfo.cvRound}}</span>
            </div>
          </div>
          <div class="dis-24">
            <div class="personal-package-list">
              <span>RL修改数量</span>
              <span>{{packageInfo.referrerCount}}</span>
            </div>
            <div class="personal-package-list">
              <span>RL修改轮次</span>
              <span>{{packageInfo.rlRound}}</span>
            </div>
          </div>
          <div class="dis-24">
            <div class="personal-package-list">
              <span>SM导师数量</span>
              <span>{{packageInfo.smCount}}</span>
            </div>
            <div class="personal-package-list">
              <span>EM导师数量</span>
              <span>{{packageInfo.emCount}}</span>
            </div>
            <div class="personal-package-list">
              <span>CM导师数量</span>
              <span>{{packageInfo.cmCount}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="personal-package-item">
      <div>
        <div class="personal-package-con">
          <div v-for="(item,index) in zoomSchedule"
               :key="index">
            <div class="dis-24">
              <div class="personal-package-list">
                <span class="personal-package-list-large">SM导师 - {{item.mentorName}}</span>
                <span></span>
              </div>
            </div>
            <div class="dis-36">
              <div class="personal-package-list">
                <span>Module 1-3 上限时间</span>
                <span>{{item.maxTime}}mins</span>
              </div>
              <div class="personal-package-list">
                <span>Module 1-3 已使用时间</span>
                <span>{{item.usedTime}}mins</span>
              </div>
              <div class="personal-package-list">
                <span>Module 1-3 剩余时间</span>
                <span>{{item.remainTime}}mins</span>
              </div>
            </div>
          </div>
          <div>
            <div class="personal-package-list-btn" v-if="isallowedit">
              <Button class="zlr-btn-default"
                      @click="replaceBookHandle">置换时间</Button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="personal-package-item">
      <div>
        <div class="personal-package-con">
          <div class="dis-24">
            <div class="personal-package-list">
              <span class="personal-package-list-large">个性化辅导</span>
              <span></span>
            </div>
          </div>
          <div class="dis-36">
            <div class="personal-package-list">
              <span>SM个性化辅导 上限时间</span>
              <span>{{smcs.maxTime}}mins</span>
            </div>
            <div class="personal-package-list">
              <span>SM个性化辅导 已使用时间</span>
              <span>{{smcs.usedTime}}mins</span>
            </div>
            <div class="personal-package-list">
              <span>SM个性化辅导 剩余时间</span>
              <span>{{smcs.remainTime}}mins</span>
            </div>
          </div>
          <div class="dis-36">
            <div class="personal-package-list">
              <span>CM个性化辅导 上限时间</span>
              <span>{{cmcs.maxTime}}mins</span>
            </div>
            <div class="personal-package-list">
              <span>CM个性化辅导 已使用时间</span>
              <span>{{cmcs.usedTime}}mins</span>
            </div>
            <div class="personal-package-list">
              <span>CM个性化辅导 剩余时间</span>
              <span>{{cmcs.remainTime}}mins</span>
            </div>
          </div>
          <div>
            <div class="personal-package-list-btn" v-if="isallowedit">
              <Button class="zlr-btn-default"
                      @click="replaceDiyHandle">置换时间</Button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="personal-package-item">
      <div>
        <p class="personal-package-prompt">注：以上所有的服务，如果您用更少的服务完成了申请，剩余时间和项目费用将不予退还</p>
      </div>
    </div>
    <!-- 置换文书辅导 -->
    <replace-book ref="repalceBook"
                  @on-success="getScheduleInfo"></replace-book>
    <!-- 置换个性化辅导 -->
    <replace-diy ref="repalceDiy"
                 @on-success="getScheduleInfo"></replace-diy>
  </div>
</template>

<script>
// api
import { getAppScheduleInfo } from '@/api/appointment'
import { getPackagesInfo } from '@/api/info'
// components
import ReplaceBook from '@/view/components/replace-book'
import ReplaceDiy from '@/view/components/replace-diy'
import isAllowEdit from '@/view/mixins/is-edit'
export default {
  name: 'personal-package',
  mixins: [isAllowEdit],
  components: {
    ReplaceBook,
    ReplaceDiy
  },
  data () {
    return {
      packageInfo: {
        detail: {}
      },
      zoomSchedule: [],
      cmcs: {},
      smcs: {}
    }
  },
  computed: {},
  mounted () {
    this.getScheduleInfo()
    this.getPackagesInfo()
  },
  methods: {
    // 获取套餐信息
    getPackagesInfo () {
      getPackagesInfo().then(res => {
        this.packageInfo = res.data.model
      })
    },
    // 获取 个性化辅导 和 导师辅导信息
    getScheduleInfo () {
      getAppScheduleInfo().then(res => {
        let data = res.data
        this.zoomSchedule = data.zoomSchedule
        this.cmcs = data.cmcs
        this.smcs = data.smcs
      })
    },
    // 置换文书
    replaceBookHandle () {
      this.$refs['repalceBook'].showHandle()
    },
    // 置换个性化辅导
    replaceDiyHandle () {
      this.$refs['repalceDiy'].showHandle()
    }
  }
}
</script>
<style lang='less' scoped>
</style>
